// Custom components
import React from "react";
import { useState } from "react";

function InputField(props) {
  const [focused, setFocused] = useState(false);
  const {
    disabled = false,
    state,
    label,
    errorMessage,
    onChange,
    id,
    ...inputProps
  } = props;

  const handleFocus = (e) => {
    setFocused(true);
  };

  return (
    <div className="formInput">
      {label === null || label === "" || label === undefined ? (
        <></>
      ) : (
        <label
          htmlFor={"input" + id}
          className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
        >
          {label}
        </label>
      )}
      <input
        {...inputProps}
        id={"input" + id}
        onChange={onChange}
        onBlur={handleFocus}
        onFocus={() =>
          inputProps.name === "confirmPassword" && setFocused(true)
        }
        disabled={disabled ?? false}
        focused={focused.toString()}
        className={` flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        }  ${props.className} `}
      />

      <span id="error-msg">{errorMessage}</span>
    </div>
  );
}

export default InputField;
